"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.create = exports["default"] = exports.SimpleRegistry = void 0;

var _defineEnumerableProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/defineEnumerableProperties"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectSpread3 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _lodash = _interopRequireDefault(require("lodash"));

var _properties = require("../utils/properties");

var _query2 = _interopRequireDefault(require("../utils/query"));

var _registry = _interopRequireDefault(require("./registry"));

var _router = _interopRequireDefault(require("./router"));

var pickBy = _lodash["default"].pickBy,
    mapValues = _lodash["default"].mapValues,
    isFunction = _lodash["default"].isFunction,
    isObject = _lodash["default"].isObject,
    has = _lodash["default"].has,
    _get = _lodash["default"].get,
    pick = _lodash["default"].pick;

var SimpleRegistry =
/*#__PURE__*/
function () {
  (0, _createClass2["default"])(SimpleRegistry, null, [{
    key: "attach",

    /**
     * Attach a registry to a host
     *
     * @example
     * 	SimpleRegistry.attach('components').to(host)
     */
    value: function attach(name) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var cache = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return {
        to: function to(target) {
          (0, _registry["default"])(target, name, options, cache);
          return _get(target, name);
        }
      };
    }
  }, {
    key: "create",
    value: function create(name) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var cache = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return new this(name, options, cache = {});
    }
    /**
     * Create a new Simple Registry
     * @param  {String} name   The name of this registry
     * @param  {Object} options =             {} Options
     * @param  {Function} options.init a function which will be called with the registry after it is initialize.
     * @param  {Function} options.fallback called whenever an invalid lookup request returns
     * @param  {Boolean} options.useDefaultExport - when a component is found, check to see if there is a default export and if so use that
     *
     * @return {SimpleRegistry}        The SimpleRegistry
     */

  }]);

  function SimpleRegistry(name) {
    var _this = this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var cache = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    (0, _classCallCheck2["default"])(this, SimpleRegistry);
    this.name = name;
    (0, _properties.enhanceObject)(this, _lodash["default"]);
    hide(this, 'options', (0, _objectSpread3["default"])({
      router: {}
    }, options, {
      name: name
    }));
    hide(this, 'createRouter', function () {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return (0, _router["default"])(_this, options);
    });
    hide(this, 'internalAliases', {});
    hide(this, 'internalRegistries', {});
    this.createRouter();
    this.attach('registry', cache);

    if (isFunction(options.init)) {
      options.init.call(this, this, options);
    }

    if (isFunction(options.componentWillRegister)) {
      this.componentWillRegister = options.componentWillRegister.bind(this);
    }

    if (isFunction(options.componentWasFound)) {
      this.componentWasFound = options.componentWasFound.bind(this);
    }

    if (isFunction(options.fallback)) {
      this.fallback = options.fallback.bind(this);
    } else if (isObject(options.fallback) && isFunction(options.fallback.lookup)) {
      this.fallback = function (lookupId) {
        return options.fallback.lookup(lookupId);
      };
    }

    if (isFunction(options.wrapper)) {
      this.wrapResult = options.wrapper.bind(this);
    }
  }

  (0, _createClass2["default"])(SimpleRegistry, [{
    key: "query",
    value: function query() {
      var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return (0, _query2["default"])(items, params);
    }
  }, {
    key: "add",
    value: function add(registry) {
      var _this2 = this;

      has(registry, 'available') && has(registry, 'lookup') ? registry.available.forEach(function (key) {
        return _this2.register(key, function () {
          return registry.lookup(key);
        });
      }) : Object.keys(registry).forEach(function (key) {
        return _this2.register(key, function () {
          return registry[key];
        });
      });
      return this;
    }
  }, {
    key: "convertToRequireContext",
    value: function convertToRequireContext() {
      var object = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this;
      var fn = this.lookup.bind(this);
      return Object.assign(fn, {
        resolve: function resolve(id) {
          var resolved = has(object, 'checkKey') ? object.checkKey.call(object, id) : has(object, id) && object[id];

          if (!resolved) {
            throw new Error("could not find ".concat(id, " in context"));
          }

          return resolved;
        },
        keys: function keys() {
          return _get(object, 'available', Object.keys(object));
        }
      });
    }
  }, {
    key: "findAliases",
    value: function findAliases(key) {
      return Object.keys(pickBy(this.internalAliases, function (v, k) {
        return k === key || v === key;
      }));
    }
    /**
     * Register a component with the registry
     *
     * @param {String} componentId
     * @param {Function} componentFn
     * @param {Object} options
     * @memberof SimpleRegistry
     */

  }, {
    key: "register",
    value: function register() {
      return this._register.apply(this, arguments);
    }
  }, {
    key: "_register",
    value: function _register(componentId, componentFn) {
      var _this3 = this;

      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var _options$formatId = options.formatId,
          formatId = _options$formatId === void 0 ? this.options.formatId : _options$formatId,
          _options$registryName = options.registryName,
          registryName = _options$registryName === void 0 ? 'registry' : _options$registryName,
          _options$namespace = options.namespace,
          namespace = _options$namespace === void 0 ? _get(this, 'options.namespace', '') : _options$namespace;

      if (typeof formatId === 'function') {
        componentId = formatId.call(this, componentId, componentFn, registryName) || componentId;
      }

      componentId = componentId.trim();

      var _this$componentWillRe = this.componentWillRegister(componentId, componentFn),
          _this$componentWillRe2 = (0, _slicedToArray2["default"])(_this$componentWillRe, 2),
          registryId = _this$componentWillRe2[0],
          componentEntry = _this$componentWillRe2[1];

      if (typeof options.alias === 'string') {
        this.alias(options.alias, registryId);
      }

      if (typeof this.options.alias === 'function') {
        var aliasMap = this.options.alias.call(this, registryId, componentFn, options);
        mapValues(aliasMap, function (realId, alias) {
          _this3.alias(alias, realId);
        });
      }

      if (typeof registryId !== 'string' && typeof componentEntry !== 'function') {
        this.componentRegistrationDidFail(componentId, componentFn, registryId, componentEntry);
        throw new Error('Component Registration Failed');
      }

      return this[registryName].register("".concat(namespace).concat(registryId), componentEntry);
    }
  }, {
    key: "alias",
    value: function alias(aliasId, realId) {
      this.internalAliases[aliasId] = realId;
      return this;
    }
  }, {
    key: "checkKey",
    value: function checkKey(componentId) {
      var registryName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'registry';

      if (this[registryName] && this[registryName].has(componentId)) {
        return componentId;
      } else if (has(this.internalAliases, componentId)) {
        return _get(this, ['internalAliases', componentId]);
      } else {
        return false;
      }
    }
  }, {
    key: "childRegistries",
    value: function childRegistries() {
      return pick(this, this.childRegistryNames);
    }
  }, {
    key: "lookupAll",
    value: function lookupAll(componentId) {
      return mapValues(pickBy(this.childRegistries(), function (reg, k) {
        return has(reg, componentId);
      }), function (reg) {
        return _get(reg, componentId);
      });
    }
  }, {
    key: "lookup",
    value: function lookup(componentId) {
      var registryName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'registry';
      var lookupId = this.willLookupById(componentId) || "".concat(componentId);
      var realKey = this.checkKey(lookupId, registryName);
      var result = this[registryName] && this[registryName].lookup(realKey);
      return result ? this.componentWasFound(result, lookupId, componentId) : this.performFallbackLookup(lookupId, componentId);
    }
  }, {
    key: "findRawMember",
    value: function findRawMember(componentId) {
      var registryName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'registry';
      var lookupId = this.willLookupById(componentId) || "".concat(componentId);
      var result = this[registryName].get(lookupId);
      return result;
    }
  }, {
    key: "enhance",
    value: function enhance(componentId, enhancerFn) {
      var registryName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'registry';
      var useDefault = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var member = this.findRawMember(componentId, registryName);

      if (member) {
        this.register(componentId, typeof enhancerFn === 'function' ? enhancerFn(member) : Object.assign(member, enhancerFn));
      }

      return this;
    }
    /**
     * Creates a primitive registry interface and attaches it to this one.
     *
     * @param  {String} name - the name of the registry, and which property to assign it to
     * @param  {Object} options - an options hash for the registry primitive
     * @return {Registry}        the registry object
     */

  }, {
    key: "attach",
    value: function attach(name, options) {
      this.constructor.attach(name, options).to(this);
      this.internalRegistries[name] = name;
      return _get(this, name);
    }
    /**
     * Attach a group of child registries to this one.
     *
     * @param  {Object} map - an object whose keys are the registry name,
     *                      and whose values are the options for the registry create method
     *
     * @return {SimpleRegistry}    Returns this registry
     */

  }, {
    key: "attachAll",
    value: function attachAll(map) {
      var target = this;
      return mapValues(map, function (options, name) {
        return target.attach(name, options);
      });
    }
    /**
     * Intercepts an attempt to lookup a component by id, giving you an opportunity
     * to alter it if you like. Can be used for aliasing, logging, or whatever.
     * This function should return a component id that will be used to access the desired
     * object in the internal registry.
     *
     * @param  {String} requestedComponentId - the component id that is being looked up
     * @return {String} - the component id that will be used to perform the lookup.
     */

  }, {
    key: "willLookupById",
    value: function willLookupById(requestedComponentId) {
      return requestedComponentId;
    }
    /**
     * A Lifecycle hook called prior to a component being registered.
     * It should return an array that contains the actual componentId
     * that should be used, and a function which returns the desired component.
     *
     * By default it will just pass the arguments back, but this exists to be
     * overridden.
     *
     * @param  {String} componentId - the id of the component that was passed to register
     * @param  {Function} component - a function that will return the component that was registered
     * @return {Array} - the componentId and function that will actually be registered.
     */

  }, {
    key: "componentWillRegister",
    value: function componentWillRegister(componentId, component) {
      return [componentId, component];
    }
    /**
     * A hook that will get called whenever a component is successfully looked up.
     * This can be used to modify the returning object however you see fit.
     */

  }, {
    key: "componentWasFound",
    value: function componentWasFound(component, lookupId, requestedComponentId) {
      // eslint-disable-line no-unused-vars
      component = component["default"] && (this.options.useDefaultExport || this.options.useDefaultExports) ? component["default"] : component;
      return isFunction(this.wrapResult) ? this.wrapResult(component, lookupId, requestedComponentId) : component;
    }
  }, {
    key: "performFallbackLookup",
    value: function performFallbackLookup(lookupId) {
      if (!this.fallback) {
        return this.componentLookupFailed(lookupId);
      }

      var result = this.fallback(lookupId);
      return result ? this.componentWasFound(result, lookupId) : this.componentLookupFailed(lookupId);
    }
    /**
     * Handle a component lookup failure.
     */

  }, {
    key: "componentLookupFailed",
    value: function componentLookupFailed(lookupId) {
      if (!this.options.silenceFailures) {
        throw new Error("Component Lookup Failed: ".concat(lookupId, ".\n\nDid you mean one of the following?\n").concat(this.available.join('\n')));
      }
    }
  }, {
    key: "allMembers",
    value: function allMembers() {
      var reg = this;
      return this.available.reduce(function (memo, key) {
        var _objectSpread2, _mutatorMap;

        return (0, _objectSpread3["default"])({}, memo, (_objectSpread2 = {}, _mutatorMap = {}, _mutatorMap[key] = _mutatorMap[key] || {}, _mutatorMap[key].get = function () {
          return reg.lookup(key);
        }, (0, _defineEnumerableProperties2["default"])(_objectSpread2, _mutatorMap), _objectSpread2));
      }, {});
    }
  }, {
    key: "asRequireContext",
    get: function get() {
      return this.convertToRequireContext();
    }
    /**
     * Returns an array of the component ids this registry knows about.
     * @return {String[]} - an array of component ids
     */

  }, {
    key: "available",
    get: function get() {
      return _get(this, 'registry.available', []);
    }
  }, {
    key: "childRegistryNames",
    get: function get() {
      return Object.keys(this.internalRegistries);
    }
  }, {
    key: "all",
    get: function get() {
      return Object.values(this.allMembers());
    }
  }]);
  return SimpleRegistry;
}();

exports.SimpleRegistry = SimpleRegistry;
var _default = SimpleRegistry;
exports["default"] = _default;

var create = function create() {
  return SimpleRegistry.create.apply(SimpleRegistry, arguments);
};

exports.create = create;

function hide(t, p, value, configurable) {
  Object.defineProperty(t, p, {
    value: value,
    configurable: configurable,
    enumerable: false
  });
}